import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { determineVideoGridPositioning, getVideoAspectRatio } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/__internal__/utils";
import { LazyVideoPlayer } from "@faire/retailer-visitor-shared/views/video/components/VideoPlayer/index";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import isChromatic from "chromatic";
import React, { useState } from "react";
import styled, { css } from "styled-components";
export var CollectionVideoTile = function(param) {
    var columnCount = param.columnCount, tileCount = param.tileCount, video = param.video, onFailedToPlayVideo = param.onFailedToPlayVideo;
    var _useState = _sliced_to_array(useState(false), 2), isVideoVisible = _useState[0], setIsVideoVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(undefined), 2), videoDimensions = _useState1[0], setVideoDimensions = _useState1[1];
    var ref = useDoActionWhenVisible(function() {
        return setIsVideoVisible(true);
    });
    return /*#__PURE__*/ _jsx(CollectionVideoTileContainer, {
        $columnCount: columnCount,
        $tileCount: tileCount,
        $videoDimensions: videoDimensions,
        "data-test-id": "collection-video-tile",
        ref: ref,
        children: !isChromatic() ? /*#__PURE__*/ _jsx(LazyVideoPlayer, {
            video: video,
            videoOptions: {
                autoplay: false,
                loop: false,
                muted: true,
                bigPlayButton: true
            },
            startPlayVideo: isVideoVisible,
            onFailedToPlayVideo: onFailedToPlayVideo,
            onLoadedMetaData: function(player) {
                setVideoDimensions({
                    width: player.videoWidth(),
                    height: player.videoHeight()
                });
            }
        }) : null
    });
};
var CollectionVideoTileContainer = styled.div.withConfig({
    componentId: "sc-710420d1-0"
})([
    "",
    ""
], function(props) {
    var positioning = determineVideoGridPositioning(props);
    return css([
        "grid-column:",
        ";grid-row:",
        ";",
        "{aspect-ratio:",
        ";}.vjs-tech{object-fit:cover;}"
    ], positioning.gridColumn, positioning.gridRow, responsiveMediaQueries.mobile, getVideoAspectRatio(props.$videoDimensions));
});
